import React, { useMemo } from 'react';
import { useTable } from 'react-table';
import { useHistory } from 'react-router-dom';
import { Badge } from 'react-bootstrap';

const InvoiceTable = ({ invoices, companyId }) => {
  const history = useHistory();

  console.log('Invoices:', invoices);
  const COLUMNS = useMemo(() => [
    {
      Header: 'Id',
      accessor: 'invoicenumber',
    },
    {
      Header: 'Kund',
      accessor: 'name',
    },
    {
      Header: 'Fakturadatum',
      accessor: 'invoicedate',
    },
    {
      Header: 'Förfallodatum',
      accessor: 'deadline',
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: props => {
        const { original } = props.row;
        const statusLabels = {
          'Draft': 'Utkast',
          'Sent': 'Skickad',
          'Partially_Paid': 'Delvis betald',
          'Paid': 'Betald',
          'Cancelled': 'Makulerad',
          'Credited': 'Krediterad'
        };
        const statusColors = {
          'Draft': 'light',
          'Sent': 'primary',
          'Partially_Paid': 'warning',
          'Paid': 'success',
          'Cancelled': 'secondary',
          'Credited': 'info'
        };
        const label = statusLabels[props.value] || props.value;
        const color = statusColors[props.value] || 'secondary';
        const isOverdue = original.is_overdue;
        return (
          <span>
            <Badge bg={color} style={isOverdue ? { border: '2px solid var(--bs-danger)' } : {}}>
              {label}
            </Badge>
            {isOverdue && (
              <Badge bg="danger" className="ms-1" style={{ fontSize: '0.65rem' }}>Förfallen</Badge>
            )}
          </span>
        );
      },
    },
  ], []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({ columns: COLUMNS, data: invoices });

  const handleRowClick = (invoiceId) => {
    history.push(`/${companyId}/view-invoice-new/${invoiceId}`);
  };

  return (
    <div className="table-responsive">
      <table {...getTableProps()} className="table">
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps()}>{column.render('Header')}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map(row => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} onClick={() => handleRowClick(row.original.id)} style={{ cursor: 'pointer' }}>
                {row.cells.map(cell => (
                  <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default InvoiceTable;
